<div >
<mat-toolbar style="background: #fff;" class="mat-elevation-z8 mat-app-background">
    <div class="logo"><img  src="assets/image/logo.png" alt="logo"></div>
    
  </mat-toolbar>
</div>